export default __webpack_public_path__ + "static/media/testing.6b92a8af.jpg";